import {dataApi} from "./data-api";
import {
  CITIES,
  COUNTRIES,
  CREW_ROLES, FINISH_COUNTRIES, FINISH_MARINAS, LICENSE_SYSTEMS, LICENSE_TYPES,
  MARINAS, OPERATORS, REGIONS,
  SET_CITIES,
  SET_COUNTRIES,
  SET_REGIONS,
  SET_YACHT_TYPES,
  SET_YACHTS,
  SHIPYARDS,
  YACHT_MODELS, YACHT_TYPES, YACHTS
} from "./data-types";
import {
  setCities,
  setCountries, setCrewRoles, setFinishCountries, setFinishMarinas, setLicenseSystems, setLicenseTypes,
  setMarinas, setOperators,
  setRegions,
  setShipyards,
  setYachtModels,
  setYachts,
  setYachtTypes
} from "./data-actions";

export const getCommonData = (query, name, lang = 'en', otherQuery) => async (dispatch) => {
  const response = await dataApi.getData(query.toLowerCase(), name, lang, otherQuery)
  switch (query) {
    case MARINAS: dispatch(setMarinas(response.data)); break
    case FINISH_MARINAS: dispatch(setFinishMarinas(response.data)); break
    case YACHT_MODELS: dispatch(setYachtModels(response.data)); break
    case SHIPYARDS: dispatch(setShipyards(response.data)); break
    case YACHT_TYPES: dispatch(setYachtTypes(response.data)); break
    case YACHTS: dispatch(setYachts(response.data)); break
    case REGIONS: dispatch(setRegions(response.data)); break
    case COUNTRIES: dispatch(setCountries(response.data)); break
    case FINISH_COUNTRIES: dispatch(setFinishCountries(response.data)); break
    case CITIES: dispatch(setCities(response.data)); break
    case CREW_ROLES: dispatch(setCrewRoles(response.data)); break
    case OPERATORS: dispatch(setOperators(response.data)); break
    case LICENSE_TYPES: dispatch(setLicenseTypes(response.data)); break
    case LICENSE_SYSTEMS: dispatch(setLicenseSystems(response.data)); break
    default: break
  }
}
